// TabContent1.js
import React, { useState, useEffect } from 'react';
import ProgressionTab from '../../../../theme/ProgressionBuilder/ProgressionTab';
import { useTheme } from '@emotion/react';
import Text from '../../../../theme/text/Text';
import { useTranslation } from 'react-i18next';
import { Box, InputBase } from '@mui/material';
import { tokens } from '../../../../../theme';
import { useDispatch } from 'react-redux';
import { setTabErrors } from '../../../../../newapi/global/progressionTabSlice';
import ShValidatedInput from '../../../../theme/inputs/ShValidatedInput';
import { useGetInvoiceCategorySelectQuery } from "../../../../../newapi/financial/invoiceCategorySlice";
import { useGetWarehousesSelectQuery } from "../../../../../newapi/warehouse/warehouseApiSlice";
import { InputDropdown } from "../../../../theme/dropdowns/InputDropdown";
import { useGetEnumsQuery } from '../../../../../newapi/global/generalApiSlice';

/**
 * TabContent1 Component
 * 
 * Props:
 * - handleDataUpdate: Function, updates the data in the Redux state.
 * - handleNext: Function, navigates to the next tab.
 */
const Content = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();
    const colors = tokens(theme.palette.mode);
    const data = { ...props.data };
    const dispatch = useDispatch();

    const [invoiceCategoryOptions, setInvoiceCategoryOptions] = useState([]);
    const { data: invoiceCategories, invoiceCategoryIsLoading } = useGetInvoiceCategorySelectQuery();
    const { data: warehouses, warehousesIsLoading } = useGetWarehousesSelectQuery();
    const [ warehouseOptions, setWarehouseOptions ] = useState([]);
    const { data: globalEnums, enumIsLoading } = useGetEnumsQuery("invoicing_frequency");
    const [invoicingFrequencies, setInvoicingFrequencies] = useState([]);

    useEffect(() => {
        setInvoicingFrequencies(globalEnums ? globalEnums["invoicing.frequency"] : []);
    },[globalEnums]);

    useEffect(() => {
        if (invoiceCategories) {
            const options = [{id: null, name: t('none')}, ...invoiceCategories];
            setInvoiceCategoryOptions(options);
        }
    }, [invoiceCategories]);

    useEffect(() => {
        if (warehouses && warehouses.success) {
            const options = [{id: null, name: t('none')}, ...warehouses.data];
            setWarehouseOptions(options);
        }
    },[warehouses]);

    const handleInput = (key, val) => {
        props.handleDataUpdate({ [key]: val });
        dispatch(setTabErrors({ ...props.errors, [key]: '' }));
    };

    return (
        <>
        <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("phone")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="phone"
                        value={data.phone ?? ""}
                        onChange={handleInput}
                        error={props.errors.phone}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                    
                </Box>
            </Box>
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("company_email")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="company_email"
                        value={data.company_email ?? ""}
                        onChange={handleInput}
                        error={props.errors.company_email}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                </Box>
            </Box>
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("website")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="website"
                        value={data.website ?? ""}
                        onChange={handleInput}
                        error={props.errors.website}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                </Box>
            </Box>
            <Box 
                sx={{
                    width:1,
                    display:"flex",
                    alignItems:"center",
                    paddingTop: 2,
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("vat_number")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="vatNumber"
                        value={data.vatNumber ?? ""}
                        onChange={handleInput}
                        error={props.errors.vatNumber}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                </Box>
            </Box>
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("eori_number")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="eoriNumber"
                        value={data.eoriNumber ?? ""}
                        onChange={handleInput}
                        error={props.errors.eoriNumber}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                    
                </Box>
            </Box>
            {warehouseOptions.length > 2 && (
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("warehouse")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <InputDropdown
                        name="warehouseId"
                        displayName="name"
                        selected={warehouseOptions ? warehouseOptions.findIndex(item => item.id === data?.warehouseId) ?? -1 : -1}
                        options={warehouseOptions ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleInput('warehouseId', warehouseOptions[selected]?.id)}
                        closeOnSelection
                    />
                </Box>
            </Box>
            )}
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("debtor_number")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="debtorNumber"
                        value={data.debtorNumber ?? ""}
                        onChange={handleInput}
                        error={props.errors.debtorNumber}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                </Box>
            </Box>
            <Box 
                sx={{
                    width:1,
                    paddingTop: 2,
                    display:"flex",
                    alignItems:"center",
                    justifyContent:"space-between",
                    gap:7
                }}
            >
                
                <Box
                    sx={{
                        width:120,
                    }}
                >
                    <Text>{t("invoice_email")}</Text>
                </Box>
                
                <Box
                    sx={{
                        flex:1,
                        backgroundColor : `${theme.palette.mode === "dark" ?colors.grey[300] : colors.grey[100]}`,
                        borderRadius:4,
                        display:"flex",
                        height:32
                    }}
                >
                    <ShValidatedInput
                        name="invoiceEmail"
                        value={data.invoiceEmail ?? ""}
                        onChange={handleInput}
                        error={props.errors.invoiceEmail}
                        sx={{
                            px:2,
                            flex:1, 
                            color:colors.txt["primary"],
                            lineHeight:"32px",
                        }}
                    />
                </Box>
            </Box>
                <Box
                    sx={{
                        width:1,
                        paddingTop: 2,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box 
                        sx={{
                            width:120,
                        }}
                    >
                        <Text noBreak>{t("invoice_category")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                    <InputDropdown
                        name="name"
                        displayName="name"
                        selected={invoiceCategoryOptions ? invoiceCategoryOptions.findIndex(item => item.id === props.data.invoiceCategoryId) ?? -1 : -1}
                        options={invoiceCategoryOptions ?? []}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleInput('invoiceCategoryId', invoiceCategoryOptions[selected]?.id)}
                        closeOnSelection
                    />
                    </Box>
                </Box>
                <Box
                    sx={{
                        width:1,
                        paddingTop: 2,
                        display:"flex",
                        alignItems:"center",
                        justifyContent:"space-between",
                        gap:7
                    }}
                >
                    <Box 
                        sx={{
                            width:120,
                        }}
                    >
                        <Text noBreak>{t("invoicing_frequency")}</Text>
                    </Box>
                    <Box display="flex"
                        // maxWidth="400px"
                        borderRadius="20px"
                        sx={{
                            flex:1,
                        }}
                    >
                    <InputDropdown
                        name="invoicingFrequency"
                        displayName="displayName"
                        changeField="name"
                        valueKey="id"
                        selected={invoicingFrequencies.findIndex(item => item === props.data?.invoicingFrequency) ?? -1}
                        options={invoicingFrequencies.map((item, index) => ({ id: index, name: item, displayName: t(`${item}`) }))}
                        noSelection={t("choose_option")} 
                        onChange={(selected) => handleInput('invoicingFrequency', invoicingFrequencies[selected])}
                        closeOnSelection
                    />
                    </Box>
                </Box>
        </>
    );
};

const OtherDetails = (props) => {
    const { t } = useTranslation();

    return (
        <ProgressionTab 
        tabId="tabOtherDetails" 
        subtitle={t('other_details_optional')} 
        step={4}
        maxSteps={4}
    >
        <Content />
    </ProgressionTab>
    )
}

export default OtherDetails;